export default "__VITE_ASSET__C01smRE5__"